const SupplierList = () => import('~/views/Supplier/ListView.vue')
const SupplierAccount = () => import('~/views/Supplier/AccountView.vue')
const SupplierAddress = () => import('~/views/Supplier/AddressView.vue')

export {
  SupplierList,
  SupplierAccount,
  SupplierAddress
}
